module.exports = __webpack_public_path__ + "static/media/michal-ux-ui.d61a31b8.png";